import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';
import { BetslipType } from '../../core/betslip-type';
import { SlipId } from '../bet-generation/models';
import { UnderMinimumStakePreCheckError } from '../validation/errors/pre-check/under-minimum-stake-pre-check-error';

export class BetslipStakeActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/stake`;

    private static readonly NOTIFY_STAKE_CHANGES = `${BetslipStakeActions.ACTION_SCHEMA}/NOTIFY_STAKE_CHANGES`;
    private static readonly TRACK_STAKE_CLICK = `${BetslipStakeActions.ACTION_SCHEMA}/TRACK_STAKE_CLICK`;
    private static readonly UPDATE_MIN_STAKE = `${BetslipStakeActions.ACTION_SCHEMA}/UPDATE_MIN_STAKE`;

    static notifyStakeChanges = createAction(BetslipStakeActions.NOTIFY_STAKE_CHANGES);
    static updateMinStake = createAction(
        BetslipStakeActions.UPDATE_MIN_STAKE,
        props<{ minStake: number; slipId: SlipId; error: UnderMinimumStakePreCheckError }>(),
    );

    static trackStakeClick = createAction(BetslipStakeActions.TRACK_STAKE_CLICK, props<{ betslipType: BetslipType; stakeAmount: number | null }>());
}
